import { defineStore } from 'pinia'
import { suggestionService } from '@/services/suggestionService'

export const useSuggestionStore = defineStore('suggestion', {
  state: () => ({
    suggestions: {
      meta: {}
    },
    suggestion: {},
    filter: {},
  }),

  actions: {
    async getSuggestions() {
      try {
        const response = await suggestionService.fetchSuggestions(this.filter);
        this.suggestions = response.data;
      } catch (error) {
        return;
      }
    },

    async getSuggestion(id) {
      try {
        const response = await suggestionService.fetchSuggestion(id);
        this.suggestion = response.data;
      } catch (error) {
        return;
      }
    },

    async addSuggestion(params) {
      
      try {
        await suggestionService.createSuggestion(params);
        return { success: true };
      }
      catch (error) {
        if (error.response && error.response.status === 422) {
          return { success: false, errors: error.response.data.errors };
        }

        return { success: false, errors: {} };
      }
    },
  }
});